import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

const cfg = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

export const firebaseConfigured = () =>
  Boolean(
    cfg.apiKey &&
      cfg.authDomain &&
      cfg.projectId &&
      cfg.appId
  );

export function getFirebaseApp() {
  return getApps()[0] || initializeApp(cfg);
}

export function getFirebaseAuth() {
  return getAuth(getFirebaseApp());
}

let verifier = null;

export async function firebaseSendOtp(
  phone,
  containerId = "recaptcha-container"
) {
  const auth = getFirebaseAuth();

  if (!verifier) {
    verifier = new RecaptchaVerifier(auth, containerId, {
      size: "invisible",
    });
  }

  return signInWithPhoneNumber(auth, `+91${phone}`, verifier);
}

export async function getFirebaseMessaging() {
  if (!(await isSupported())) {
    return null;
  }

  return getMessaging(getFirebaseApp());
}

export async function getFCMToken() {
  const messaging = await getFirebaseMessaging();

  if (!messaging) {
    return null;
  }

  if (!process.env.REACT_APP_FIREBASE_VAPID_KEY) {
    throw new Error("Firebase VAPID key is not configured");
  }

  if (!("Notification" in window)) {
    throw new Error("Browser notifications are not supported");
  }

  if (Notification.permission !== "granted") {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      return null;
    }
  }

  const registration =
    await navigator.serviceWorker.register("/firebase-messaging-sw.js");

  await navigator.serviceWorker.ready;

  return getToken(messaging, {
    vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    serviceWorkerRegistration: registration,
  });
}

export async function listenForForegroundMessages(callback) {
  const messaging = await getFirebaseMessaging();

  if (!messaging) {
    return () => {};
  }

  return onMessage(messaging, callback);
}
